export default "__VITE_ASSET__HJL4Laux__"